var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group button-switch-component"},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.onInput}}),_c('span',{staticClass:"slider"})]),_c('b',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }